<template>
    <button v-bind:type="btnType" v-on:click.prevent="formCancelled" v-bind:class="btnClass"> {{ btnText }} </button>
</template>

<script>
import {EventBus} from "../../EventBus";

export default {
        name: "FormCancellationButton",
        props: {
            btnClass: {
                type: String,
                default: 'btn btn-danger',
            },
            btnType: {
                type: String,
                default: 'button',
            },
            btnText: {
                type: String,
                default: 'Cancel'
            }
        },
        methods: {
            formCancelled: function() {
                EventBus.emit('all-forms-cancelled');
            }
        }
    }
</script>

<style scoped>

</style>
